import { render } from "./Ourstore.vue?vue&type=template&id=e6520f82&scoped=true"
import script from "./Ourstore.vue?vue&type=script&lang=js"
export * from "./Ourstore.vue?vue&type=script&lang=js"

import "./Ourstore.vue?vue&type=style&index=0&id=e6520f82&scoped=true&lang=css"

import exportComponent from "/Users/macbook/Desktop/SILA/Web/phone/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e6520f82"]])

export default __exports__